export default __webpack_public_path__ + "static/media/chevron-down-mint.9f2b34c9.svg";